import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import { KmlLayer } from 'google-react-maps';

class MapCreatorKMLLayers extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { current_map, hidden_kml_layers } = this.props.mapCreator;
    return (
      <div>
      {current_map && current_map.properties.kml_layers ? (
        current_map.properties.kml_layers
        .filter(layer => !hidden_kml_layers.includes(layer._id))
        .map(file => (
          <KmlLayer
            key={file._id}
            url={file.url}
            preserveViewport={true}
            screenOverlays={true}
            zIndex={1}
            map={this.props.map}
            maps={this.props.maps}
          />
        ))
      ) : null}
      </div>
    )
  }
}

export default mapCreatorConnect(MapCreatorKMLLayers);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-creator-kml-layers.js